import { useBuildingStore } from '../../stores/buildingStore'
import '../../styles/panels.css'

interface PersonnelPanelProps {
  onFocusBadge?: (badgeCode: string) => void
}

const STATUS_COLORS: Record<string, string> = {
  present: '#4ade80',
  absent: '#9ca3af',
  alerte: '#ef4444',
}

export default function PersonnelPanel({ onFocusBadge }: PersonnelPanelProps) {
  const badges = useBuildingStore((s) => s.badges)

  const presentCount = badges.filter((b) => b.status === 'present').length

  return (
    <div className="personnel-panel">
      <div className="panel-section__title">Personnel</div>
      <div className="personnel-panel__summary">
        {presentCount} presents / {badges.length} total
      </div>
      <div className="personnel-panel__list">
        {badges.map((badge) => (
          <button
            key={badge.id}
            className="personnel-panel__item"
            onClick={() => onFocusBadge?.(badge.badge_code)}
          >
            <span
              className="personnel-panel__dot"
              style={{ background: STATUS_COLORS[badge.status] ?? STATUS_COLORS.present }}
            />
            <span className="personnel-panel__name">{badge.name}</span>
            <span className="personnel-panel__code">{badge.badge_code}</span>
            <span
              className="personnel-panel__status"
              style={{ color: STATUS_COLORS[badge.status] ?? STATUS_COLORS.present }}
            >
              {badge.status}
            </span>
          </button>
        ))}
        {badges.length === 0 && (
          <p className="personnel-panel__empty">Aucun badge</p>
        )}
      </div>
    </div>
  )
}
